import * as angular from 'angular';

const selectOnClickDirective = function () {
  return {
    link: function (scope: angular.IScope, element) {
      function selectText(el) {
        const selection = window.getSelection();
        selection.removeAllRanges();

        const range = document.createRange();
        range.selectNode(el);
        selection.addRange(range);
      }

      element.bind('click', function () {
        if (this.nodeName === 'INPUT') {
          this.select();
        } else {
          selectText(this);
        }
      });
    },
  };
};

angular.module('mode.components').directive('selectOnClick', selectOnClickDirective);
